export default "__VITE_ASSET__e749af99__"